import AdminLayout from "../../../components/admin/layout/AdminLayout";
import CreateManager from "../../../components/admin/manager/CreateManger";

function CreateManagerPage() {
  return (
    <AdminLayout>
      <CreateManager />
    </AdminLayout>
  );
}

export default CreateManagerPage;
